import { MakeCall } from './createMakeCall';
import { ListingPhoto } from './types/Listing';

const confirmListingPhotoUpload =
  (makeCall: MakeCall) => (listingId: number, photoId: number) =>
    makeCall<ListingPhoto[]>(
      'PUT',
      `/api/v2/listing/${listingId}/photo/${photoId}/confirm`,
    );
export { confirmListingPhotoUpload };
